export default "__VITE_PUBLIC_ASSET__b064bafc__"